<template>
  <div id="course-create-details-tab">
    <div class="vx-col w-full">
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <vs-input v-model="dataLocal.id" class="w-full" label-placeholder="Pool ID" @change="labUpdateData" />
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <vs-input v-model="dataLocal.vendor" class="w-full" label-placeholder="Pool Vendor" @change="labUpdateData" />
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <vs-input v-model="dataLocal.product" class="w-full" label-placeholder="Pool Product" @change="labUpdateData" />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button color="success" type="filled" class="mb-2 mr-2" @click="submitData">Create Lab Pool </vs-button>
          <vs-button color="warning" type="border" class="mb-2 ml-2" @click="resetData">Reset </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import axios from 'axios';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),

      status_options: ['active', 'hidden', 'disabled'],

      pools: [],
    };
  },
  components: {
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    labUpdateData() {
      this.$emit('update_lab_data', this.dataLocal);
    },
    submitData() {
      this.$emit('insert_lab_data', this.dataLocal);
    },
    resetData() {
      this.dataLocal = { module_name: undefined, module_description: undefined, module_status: undefined };
      this.labUpdateData();
    },
    get_pools() {
      this.$httpLabs
        .get('labs/pools')
        .then((response) => {
          this.pools = response.data.rows.map((obj) => obj.id);
        })
        .catch((error) => {});
    },
  },
  created() {
    this.get_pools();
  },
};
</script>

<style scoped></style>
